import { render, staticRenderFns } from "./SocialSidebar.vue?vue&type=template&id=5d622202&scoped=true"
import script from "./SocialSidebar.vue?vue&type=script&lang=js"
export * from "./SocialSidebar.vue?vue&type=script&lang=js"
import style0 from "./SocialSidebar.vue?vue&type=style&index=0&id=5d622202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d622202",
  null
  
)

export default component.exports